import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import PremiumPackage from '../PremiumPackage/PremiumPackage';
import UserPackages from '../UserPackages/UserPackages';
import PremiumPackageDetails from '../PremiumPackageDetails/PremiumPackageDetails';
import {
  getTvSubscriptions,
  getSocList,
  setExistingPackages,
  setSuggestedPackages,
  reportAnalytics,
  showPackageDetails,
  showSubscriptionDetails,
  clearAll,
  setUserTvSuspended,
  goToPage,
} from '../PremiumPackagesHolder/PremiumPackagesHolderSlice';
import CellcomTvSubscriptions from '../CellcomTvSubscriptions/CellcomTvSubscriptions';
import FailureScreen from '../../../Shared/FailureScreen/FailureScreen';
import Config from '../../../../Config';
import EpiContext from '@episerver/spa-core/Spa';

const premiumPackagesHolder = (props) => {
  const [showPackages, setShowPackages] = useState(false);

  useEffect(() => {
    props.clearAll();
    props.getTvSubscriptions();
  }, []);

  useEffect(() => {
    if (props.cellcomTvList) {
      if (props.cellcomTvList.length == 1) {
        props.getSocList(props.selectedCellcomTvProd.subscriberNo);
        //TODO: getPremiumPackages
      }
    }
  }, [props.cellcomTvList]);

  useEffect(() => {
    if (props.selectedCellcomTvProd) {
      if (props.selectedCellcomTvProd.subStatus == 'A') {
        props.getSocList(props.selectedCellcomTvProd.subscriberNo);
        //TODO: getPremiumPackages

      } else {
        props.setUserTvSuspended(true);
      }
    }
  }, [props.selectedCellcomTvProd]);

  useEffect(() => {
    if (props.socList) {
      createUserPackagesList(); //TODO: DELETE - DO at AsyncThunk
      setShowPackages(true);
    }
    if ((props.socList == null && props.actionSuccess) || (props.socList == null && props.actionFail)) {
      props.getSocList(props.selectedCellcomTvProd.subscriberNo);
      //TODO: getPremiumPackages
    }
  }, [props.socList]);

  const getSelectedPackageData = (item) => {
    let packageData = {};
    return (packageData = {
      packageName: item.packageName && item.packageName.value,
      description: item.description && item.description.value,
      price: item.price && item.price.value,
      desktopImage: item.desktopImage.value && item.desktopImage.value.url,
      mobileImage: item.mobileImage.value && item.mobileImage.value.url,
      isShowWarning: item.isShowWarning && item.isShowWarning.value,
      lawText: item.lawText && item.lawText.value,
      warningText: item.warningText && item.warningText.value,
      callbackCode: props.iContent.callbackCode && props.iContent.callbackCode.value,
      daysDuration: item.daysDuration && item.daysDuration.value,
      existedPackageOnly: item.existedPackageOnly && item.existedPackageOnly.value,
      channelsList: item.listChannels.expandedValue && item.listChannels.expandedValue,
      subscriptionList: item.listSubscription.expandedValue && item.listSubscription.expandedValue,
    });
  };

  const createUserPackagesList = () => { //Get from BACKEND
    let tempExistedPackages = [];
    let tempSuggestedPackages = [];
    props.iContent.listPackages.expandedValue.map(function (pack, packIndex) { //חבילות
      pack.listSubscription.expandedValue.map(function (subscription, subscriptionIndex) { //מסלולים
        subscription.socsList.expandedValue.map(function (soc, socIndex) {
          const found = props.socList.find((el) => el.socName.trim() === soc.socName.value.trim());
          if (found) {
            if (!tempExistedPackages.some((n) => n.name === props.iContent.listPackages.expandedValue[packIndex].packageName.value)) {
              tempExistedPackages.push({
                name: pack.packageName.value,// PremiumPackageExistedCustomerContentData - עריכת תוכן
                packIndex: packIndex,
                subscriptionIndex: subscriptionIndex,
                productID: subscription.productID.value, // SubscriptionsContentData - עריכת תוכן
                expired: found.expirationDate, //ממשק קטלוג
                serviceType: found.serviceType, //ממשק - לבדוק אם צריך
                socTitle: soc.socTitle.value, //SocContentData - עריכת תוכן
                socName: soc.socName.value, //SocContentData - עריכת תוכן
              });
            }
          }
        });
      });
      if (!tempExistedPackages.some((n) => n.name === props.iContent.listPackages.expandedValue[packIndex].packageName.value)) {
        tempSuggestedPackages.push({
          name: props.iContent.listPackages.expandedValue[packIndex].packageName.value,
        });
      }
    });
    props.setExistingPackages(tempExistedPackages); // List of objects 
    props.setSuggestedPackages(tempSuggestedPackages); // List of packageName
  };

  let checkIfSuggest = (pack) => { 
    if (props.suggestedPackagesList.some((n) => n.name === pack.packageName.value)) {
      return true;
    }
  };

  let noUserPackagesReport = () => {
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'visibility_10',
      eventLabel: 'element_12',
    });
    return null;
  };

  let allPackagesExist = () => {
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'visibility_17',
      eventLabel: 'element_19',
    });
    return (
      <div className='all_packages'>
        <Image src={require('../images/all_packages.png')} alt='חבילות' />
        <p className='all_packages_title'>רואים שאתם רואים טוב :)</p>
        <p className='all_packages_text'>יש לכם את כל חבילות הפרימיום שלנו</p>
      </div>
    );
  };

  const packages = () => {
    if (props.existingPackagesList) {
      props.reportAnalytics({
        eventCategory: 'premium_packages',
        eventAction: 'visibility_3',
        eventLabel: props.existingPackagesList.length,
      });
    }

    return (
      <div className={props.isShowPackageDetails ? 'hidden' : undefined}>
        <div className='header'>
          <p>{window.Config.brand_Name_HE} TV</p>
          <p>חבילות פרימיום </p>
        </div>
        {props.existingPackagesList && props.existingPackagesList.length > 0 ? (
          <UserPackages packages={props.existingPackagesList} />
        ) : (
          noUserPackagesReport()
        )}
        {props.suggestedPackagesList && props.suggestedPackagesList.length > 0 ? ( //חבילות למכירה
          <>
            <p className='select-package-text'>בחרו חבילה שתרצו להוסיף</p>
            {props.iContent.listPackages.expandedValue.map(function (item, index) { //todo: premiumPackages -  get from catalog + epi  
              if (checkIfSuggest(item)) { //חבילות למכירה
                const packageData = {
                  packageName: item.packageName && item.packageName.value, // עריכת תוכן
                  price: item.price && item.price.value, // עריכת תוכן - TODO: get from catalog
                  desktopImage: item.desktopImage.value && item.desktopImage.value.url, //עריכת תוכן
                  mobileImage: item.mobileImage.value && item.mobileImage.value.url,// עריכת תוכן
                  channelsList: item.channelsList && item.channelsList.value,// עריכת תוכן
                  isOnlyOneSubscription: item.listSubscription.expandedValue.length == 1 ? true : false, //רשימת מסלולים מקטלוג
                  isDailySubscriptionIncludes: item.listSubscription.expandedValue.some((s) => s.daysDuration.value != 30),//רשימת מסלולים מהקטלוג
                  lowestPrice: Math.min.apply(
                    Math,
                    item.listSubscription.expandedValue.map(function (x) {
                      return x.price.value;
                    })
                  ),
                };
                if (!item.existedPackageOnly.value) { //חבילה קיימת בלבד - לא ניתן לרכוש (תוכן למבוגרים) = existedPackageOnly 
                  return (
                    <div key={index}>
                      <PremiumPackage data={packageData} idx={index} />
                    </div>
                  );
                }
              }
            })}
          </>
        ) : (
          allPackagesExist()
        )}
      </div>
    );
  };

  const selectTvUser = () => {
    props.goToPage('selectTvUser');
    return <CellcomTvSubscriptions tvUsersList={props.cellcomTvList} />;
  };

  function handleErrorPageClose() {
    EpiContext.navigateTo(Config.lobbyUrl);
  }

  return (
    <div>
      {props.isGeneralError ? (
        <FailureScreen errorId={63} onclick={handleErrorPageClose} />
      ) : (
        <div>
          {props.isUserTvSuspended ? (
            <FailureScreen errorId={62} onclick={handleErrorPageClose} />
          ) : (
            <>
              {props.isShowCellcomTvProd ? (
                selectTvUser()
              ) : props.socList ? (
                <div>
                  <div className='premium-packages-holder'>
                    {showPackages ? packages() : null}
                    {props.isShowPackageDetails ? (
                      <PremiumPackageDetails
                        packageInfo={getSelectedPackageData(props.iContent.listPackages.expandedValue[props.selectedPackageIndex])}
                      />
                    ) : null}
                  </div>
                </div>
              ) : props.socList == false ? ( // free month
                <FailureScreen errorId={62} onclick={handleErrorPageClose} />
              ) : null}
              {props.notTvUser ? <FailureScreen errorId={61} onclick={handleErrorPageClose} /> : null}
            </>
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isShowPackageDetails: state.premiumPackages.isShowPackageDetails,
    selectedPackageIndex: state.premiumPackages.selectedPackageIndex,
    isShowCellcomTvProd: state.premiumPackages.isShowCellcomTvProd,
    cellcomTvList: state.premiumPackages.cellcomTvList,
    selectedCellcomTvProd: state.premiumPackages.selectedCellcomTvProd,
    socList: state.premiumPackages.socList,
    existingPackagesList: state.premiumPackages.existingPackagesList,
    suggestedPackagesList: state.premiumPackages.suggestedPackagesList,
    actionSuccess: state.premiumPackages.actionSuccess,
    actionFail: state.premiumPackages.actionFail,
    notTvUser: state.premiumPackages.notTvUser,
    isUserTvSuspended: state.premiumPackages.isUserTvSuspended,
    isGeneralError: state.premiumPackages.isGeneralError,
  };
};

const mapDispatchToProps = {
  getTvSubscriptions,
  getSocList,
  setExistingPackages,
  setSuggestedPackages,
  showPackageDetails,
  showSubscriptionDetails,
  reportAnalytics,
  clearAll,
  setUserTvSuspended,
  goToPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(premiumPackagesHolder);
